export default __webpack_public_path__ + "static/media/knitting-icon.77d1ca45.svg";